"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJumpOptions = getJumpOptions;
exports.jumpAddArticle = jumpAddArticle;
exports.jumpDelArticle = jumpDelArticle;
exports.jumpListArticle = jumpListArticle;
exports.selectCard = selectCard;
exports.selectJumpUrl = selectJumpUrl;
exports.transportJumpType = transportJumpType;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var JUMPOPTIONS = [{
  title: '装修页',
  key: 'skin',
  baseUrl: '/pages/activity/skin_activity/index',
  hasParams: true,
  helpTips: '参数格式为：skinId= 【示例：skinId=35】'
}, {
  title: '分类页',
  key: 'cate',
  baseUrl: '/pages/goods_cate/goods_cate',
  hasParams: true,
  helpTips: '参数格式为：scid=&twoId= 【示例：scid=35&twoId=100】，scid为1级分类id，twoId为2级分类id；如果为来一票京东或者山姆的分类，则需加上&type=lypJd或者&type=lypSam，【示例：scid=35&twoId=100&type=lypJd】'
}, {
  title: '新分类页',
  key: 'lypCate',
  baseUrl: '/pages/jingdong/lypMemu/index',
  hasParams: true,
  helpTips: '参数自动生成：scid为1级分类id（必填），twoId为2级分类id（选填），type可选lypJd、lypSam或zy。'
}, {
  title: '活动页',
  key: 'active',
  baseUrl: '/pages/users/home_active/index',
  hasParams: true,
  helpTips: '参数格式为：id= 【示例：id=5】'
}, {
  title: '点餐列表',
  key: 'meal',
  baseUrl: '/pages/ordermeal/mealList/index',
  hasParams: true,
  helpTips: '参数格式为：brandId= 【示例：brandId=5】<br>1:肯德基；2:麦当劳；3:奈雪；4:星巴克；5:瑞幸；6:喜茶；7:库迪'
}, {
  title: '商品详情',
  key: 'goodsDetail',
  baseUrl: '/pages/goods/goods_details/index',
  hasParams: true,
  helpTips: '参数格式为：id=id&productSource=0【示例：id=63&productSource=0 注意：若为京东商品productSource=1】'
}, {
  title: '地区特产',
  key: 'area',
  baseUrl: '/pages/users/specialty/index',
  hasParams: false
}, {
  title: '兑换专区',
  key: 'card',
  baseUrl: '/pages/users/card_convert/index',
  hasParams: false
}, {
  title: '优惠券领取页',
  key: 'couponReceive',
  baseUrl: '/pages/activity/consumption_voucher/index',
  hasParams: true,
  helpTips: '参数格式为：couponId= 【示例：couponId=123】'
}, {
  title: '线下展码',
  key: 'payQrcode',
  baseUrl: 'zhanma',
  hasParams: false
}, {
  title: '蛋糕品牌列表',
  key: 'cake',
  baseUrl: '/pages/cake/cakebrand-list/index',
  hasParams: true,
  helpTips: '参数格式为：initType= 【示例：initType=0】注意：0:全部品牌；ship:配送到家；take:到店消费；'
}, {
  title: '首页',
  key: 'home',
  baseUrl: 'home',
  hasParams: false
}, {
  title: '小程序跳转',
  key: 'miniProgram',
  baseUrl: 'miniProgram',
  hasParams: true,
  paramInput: 'appId',
  helpTips: '请输入目标微信小程序的 AppID，例如：wxXXXXXXXXXXXXXXXX'
}, {
  title: '其他指定页面',
  key: 'other',
  baseUrl: '',
  hasParams: false
}, {
  title: '核销门店地图页',
  key: 'storeMap',
  baseUrl: '/pages/users/store_map/index',
  hasParams: true,
  helpTips: '参数格式为：offlineSupplierId= 【示例：offlineSupplierId=221 跳转221供应商的门店列表； offlineSupplierId= 跳转全部供应商门店列表】 221是核销供应商id'
}, {
  title: '多商户店铺页',
  key: 'rsTakeout',
  baseUrl: '/pages/rs_takeout/rs_takeout_detail/index',
  hasParams: true,
  helpTips: '外卖需填写店铺id、店铺类型id；团购/酒店自动带 detailType=2，团购 type=2，酒店 type=3；一级分类id、二级分类id非必填。'
}];
function getJumpOptions() {
  return JUMPOPTIONS;
}
function transportJumpType(type) {
  var index = JUMPOPTIONS.findIndex(function (item) {
    return item.key == type;
  });
  return JUMPOPTIONS[index] || {};
}

/**
 * 列表
 */
function jumpListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/company-design-auth/list',
    method: 'GET',
    params: pram
  });
}

/**
 * 更新
 */
function jumpAddArticle() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/company-design-auth/saveAndUpdate',
    method: 'post',
    data: data
  });
}

/**
 * 删除
 */
function jumpDelArticle(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: "/admin/company-design-auth/delete",
    method: 'get',
    params: data
  });
}

/**
 * 下拉选择
 */
function selectCard(keyword) {
  return (0, _request.default)({
    url: "/admin/fudou/fucard/select",
    method: 'get',
    params: {
      keyword: keyword
    }
  }).then(function (res) {
    return res && res.length ? res.map(function (item) {
      var _ref = item || {},
        id = _ref.id,
        card_name = _ref.card_name;
      return _objectSpread(_objectSpread({}, item), {}, {
        card_name: "".concat(card_name, "\u3010").concat(id, "\u3011")
      });
    }) : [];
  });
}

/**
 * 链接-自动补全
 */
function selectJumpUrl(keyword) {
  var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _request.default)({
    url: "/admin/company-design-auth/autoList",
    method: 'get',
    params: _objectSpread({
      keyword: keyword
    }, extraParams)
  });
}